module.exports = __webpack_public_path__ + "img/cover3.e5e551f4.png";